module.exports = __webpack_public_path__ + "static/img/fae9d32a8d8a367d81a90edc6dd1911.72eb4576.jpg";